import React, { useState, useEffect } from "react";
import '../../../styles/vendor.css';
import {Modal} from "@appkit4/react-components/modal"
import ModalFooter from "@appkit4/react-components/esm/modal/ModalFooter";
import EditVendor from './editVendor'
import displayToastMessage from "../../Common/Alert/displayToastMessage";
import PropTypes from 'prop-types';
import {Table, Column} from "@appkit4/react-components/table";
import { Input } from "@appkit4/react-components/field";
import { Pagination } from "@appkit4/react-components/pagination";
import APIService from "../../../services/apiAxiosService.js";
import useHttp from "../../../hooks/useHttp.js";
import { Loading } from '@appkit4/react-components/loading';
export default function SelfAssessment(props) {
    const Role= Number(sessionStorage.getItem("roleId"));
    const [messageScreen, setMessageScreen] = useState(false)
    const [modalVisible, setModalVisible] = useState(false);
    const [selfAssessmentData, setSelfAssessmentData] = useState([]);
    const [tableData, setTableData] = useState([])
    const [wpCategory,setCategory]= useState([])
    const { sendRequest: getWorkprogramCategoryData } = useHttp();
    const { sendRequest: getSelfAssessmentById } = useHttp();
    const { sendRequest: getAssessmentByWPID } = useHttp();
    const [loader, setLoader] = useState(false);
    const [tableDataReviewAssessment, setTableDataReviewAssessment] = useState([]);
    const [search, setSearch] = useState("");
    const [filter, setFilter] = useState([]);
    const [current, setCurrent] = useState(1);
    const [totalPage, setTotalPage] = useState(500);
    const {getAllInitialData}=props;
const[workProgrammeName,setWorkProgrammeName] = useState();

    useEffect(() => {
        if(selfAssessmentData.length && tableData.length && wpCategory.length) {
            setMessageScreen(true);
        }
    }, [selfAssessmentData,tableData,wpCategory]);

    useEffect(() => {
        setTableDataReviewAssessment(props.DataAssessment);
        setFilter(props.DataAssessment);
        let totalPageLength = Math.ceil((props.DataAssessment?.length)/10);
        if (totalPageLength === 0) {
        totalPageLength = 1;
        }
        setTotalPage(totalPageLength);
    }, [props.DataAssessment]);

    useEffect(() => {
        const result = tableDataReviewAssessment?.filter((assessmentList) => {
          let searchParam = `AID${assessmentList?.assessment_id.toString()}`
          return searchParam.toLowerCase().match(search.toLocaleLowerCase());
        });
        setFilter(result);
        let totalPageLength = Math.ceil((result?.length)/10);
        if (totalPageLength === 0) {
        totalPageLength = 1;
        }
        setTotalPage(totalPageLength);
      }, [search]);

    const responseHandler = (result) => {
        if (result) {
            setSelfAssessmentData(result.MSG)
            let data = result.MSG[0]
            getByWPRequestID(data.workprogramid)
        } else {
            displayToastMessage(
                "Something went wrong, Please try again!",
                "error"
            );
        }
    }

    const errorHandler = () => {
        displayToastMessage("Something went wrong, Please try again!", "error");
    }

    const getAllInitialDataByID = async (ID) => {
        getSelfAssessmentById(APIService.getSelfAssessmentById(ID), responseHandler, errorHandler)
    }
    const getByWPRequestID = async (id) => {
        getAssessmentByWPID(APIService.getAssessmentByWPID(id), (res) => {
            /*work programme questionaire remove by other profile then vendor can't see those ans  */
            const filteredData = JSON.parse( res?.MSG[0]?.asscategory_data).filter(
                (item) => item.questionIDToggle ===true
              );
                setTableData(filteredData) 
                if(res.MSG[0].workprogramname!=undefined){
                    getWPCategoryData(res.MSG[0].workprogramname)
                    setWorkProgrammeName(res.MSG[0].workprogramname);
                  }
        })
    };

    const getWPCategoryData= async (id) => {
        getWorkprogramCategoryData(APIService.getWorkprogramCategoryData(id), (res) => {
            setCategory(res.MSG);
            setLoader(false);
          })
      };

      function formatDate(date) {
        let newDate = ""
    if (date && date !== null) {
      let d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    newDate = [day, month, year].join('-')
    }
    return newDate
      }

    const handleCancel = () => {
        setModalVisible(false);
        setSearch("");
    };
    const handleConfirm = () => {
        setModalVisible(false);
        let msg = "Record deleted successfully"
        displayToastMessage(msg, "success")
        setSearch("");
    };

    const sendBackHandler = () => {
        setMessageScreen(false);
        setSearch("");
    }

    const sortFuncForOrder1 = (a, b) => {
        const firstOrderId = (a.assessment_id.toString()).charAt(1);
        const secondOrderId = (b.assessment_id.toString()).charAt(1);
        return firstOrderId > secondOrderId ? 1 : -1;;
      }
      
    const sortFuncForOrder2 = (a, b) => {
        const firstOrderId = (a.assessment_id.toString()).charAt(1);
        const secondOrderId = (b.assessment_id.toString()).charAt(1);
        return firstOrderId < secondOrderId ? 1 : -1;;
    }
    
    const renderAssessmentID = (row) => {
        let assessmentID = "AID"+row?.assessment_id;
        return <div>{assessmentID}</div>
    }
    
    const renderEndDate = (row) => {
        return formatDate(row?.last_assessment_date);
    }
      
    const renderNextPlannedDate = (row) => {
        return formatDate(row?.next_planned_date);
    }

    const renderActionCell = (row) => {
        if(row?.assessor_assessment_status === 'Approved' && Role === 5) {
            return (
                ''
                // <span class=" Appkit4-icon icon-delete-fill action-icon pointer" title="Delete the Assessment" onClick={() => handleDeleteButton(row)}></span>
            )
        }
        else if (row?.vendor_response_status === "Completed" && row?.vendor_review_status === "Conducted") {
            return (
            <>
                {/* <span class="Appkit4-icon icon-delete-fill action-icon pointer disabledVendor" title="Delete the Assessment" onClick={() => handleDeleteButton(row)}></span>&nbsp; */}
                <span class="Appkit4-icon icon-edit-fill pointer disabledVendor action-icon" title="Update the Assessment" onClick={() => handleEditButton(row)}></span>
            </>
            )
        }
        else {
            return (
            <>
                {/* <span class="Appkit4-icon icon-delete-fill action-icon pointer disabledVendor" title="Delete the Assessment" onClick={() => handleDeleteButton(row)}></span>&nbsp; */}
                <span class="Appkit4-icon icon-edit-fill pointer action-icon" title="Update the Assessment" onClick={() => handleEditButton(row)}></span>
            </>
            ) 
        }
    }

    const handleDeleteButton = (row) => {
        setModalVisible(true);
        setSearch("");
    }

    const handleEditButton = (row) => {
        if(row?.assessment_id){
            setLoader(true);
            getAllInitialDataByID(row?.assessment_id)
        }
        setSearch("");
    }

    const renderAssessmentDate = (row) => {
        return formatDate(row?.end_date_assessment);
      }

    const renderStatus=(row)=>{
        let status;
if(row.vendor_response_status==null)
    {
        status='Save'
    }
    else{
        status=row.assessor_assessment_status
    }
    return status;
    }
    
    return (
        <div className="">
            {messageScreen ?
                <EditVendor sendBack={sendBackHandler} workProgrammeName={workProgrammeName} vendorComment={props.DataAssessment} SelfAssessmentData={selfAssessmentData} tableDataProp={tableData} getAllInitialData={getAllInitialData} wpCategoryData={wpCategory} />
                :
                <div className="col-lg-12 mt-3 pl-1">
                    {tableDataReviewAssessment.length > 0 ? (
                        <Input
                        type="text"
                        title= "Search Assessment ID"
                        value={search}
                        className="ap-field-wrapper-tableSearch"
                        onChange={(e) => setSearch(e)}
                      /> 
                    ) : ""}
              <div className="ap-table-demo">
                <Table originalData={filter} hasTitle currentPage={current} pageSize={10} className={filter.length === 0 ? "overFlow" : "biaTableBU"}>
                    <Column field="assessment_id" sortKey={filter.length > 0 ? "assessment_id" : ""} sortFunc1={sortFuncForOrder1} sortFunc2={sortFuncForOrder2} renderCell={renderAssessmentID} className={filter.length === 0 ? "" : "oneFifty"}>Assessment ID</Column>
                    <Column field="vendor_name" sortKey={filter.length > 0 ? "vendor_name" : ""} className={filter.length === 0 ? "" : "oneSeventy"}>Third Party Name</Column>
                    <Column field="criticality" sortKey={filter.length > 0 ? "criticality" : ""}>Criticality</Column>
                    <Column field="assessor_name" sortKey={filter.length > 0 ? "assessor_name" : ""} className={filter.length === 0 ? "" : "oneSixty"}>Assessor Name</Column>
                    <Column field="category" sortKey={filter.length > 0 ? "category" : ""} className={filter.length === 0 ? "" : "ninty"}>Category</Column>
                    <Column field="assessor_assessment_status" sortKey={filter.length > 0 ? "assessor_assessment_status" : ""} className={filter.length === 0 ? "" : "fifty"} renderCell={renderStatus}>Status</Column>
                    <Column field="end_date_assessment" sortKey={filter.length > 0 ? "end_date_assessment" : ""} renderCell={renderAssessmentDate} className={filter.length === 0 ? "" : "oneNinty"}>Assessment End Date</Column>

                    <Column field="assessment_id"
                    className={filter.length === 0 ? "" : "oneHundred"}
                    renderCell={renderActionCell}
                    >Action</Column>
                </Table>
                {filter.length === 0 ? (
                  <div className="noData">
                  No data available in table
                  </div>
                  ) : ("")}
                  </div>
                <Pagination
                  defaultCurrent={1}
                  current={current}
                  total={totalPage}
                  onPageChange={(page) => setCurrent(page)}
                >
                </Pagination>
            </div>
            }
            {
                loader &&(
                    <div className="row" id="preloader">
                    <div className="col-12 col-lg-12 loader-margin text-center loadingCss">
                      <div className="a-loading a-primary a-m-10 loadingText" role="status">
                       Loading...
                       <Loading loadingType='circular' indeterminate={true} compact={false}></Loading>
                      </div>
                    </div>
                  </div>
                  )
            }
            <div>
                <Modal
                    className="baseline-modal-showcase"
                    visible={modalVisible}
                    onCancel={handleCancel}
                    bodyStyle={{ maxHeight: "280px" }}
                    footerStyle={{ paddingTop: "8px", marginTop: "-8px"}}
                    modalStyle={{ width: "49.75rem" ,maxHeight:"fit-content" }}
                >
                      <div className="modal-title">
                        Are you sure you want to delete the Request?
                        </div>
                    <ModalFooter>
                        <button
                            type="button"
                            className="cancel-button"
                            onClick={handleCancel}
                        >
                            No
                        </button>

                        <button
                            type="submit"
                            className="save-button m-l-2 removeRadius"
                            onClick={() => handleConfirm()}
                        >
                            Yes
                        </button>
                    </ModalFooter>
                </Modal>
            </div>
        </div>
    )
};

SelfAssessment.propTypes = {
  getAllInitialData:PropTypes.func,
  DataAssessment:PropTypes.array
 }
